// Chakra Imports
import {
    Flex,
    useColorModeValue
} from '@chakra-ui/react';
import {SidebarResponsive} from 'components/sidebar/Sidebar';
import PropTypes from 'prop-types';
import React from 'react';
import routes from 'routes.js';

export default function HeaderLinks(props) {
    const {secondary} = props;
    let menuBg = useColorModeValue('white', 'navy.800');
    const shadow = useColorModeValue(
        '14px 17px 40px 4px rgba(112, 144, 176, 0.18)',
        '14px 17px 40px 4px rgba(112, 144, 176, 0.06)'
    );
    return (
        <Flex
            display={{ sm: "block", xl: "none" }}
            position={'fixed'}
            top={3}
            right={3}
            w={'auto'}
            alignItems="center"
            flexDirection="row"
            bg={menuBg}
            flexWrap={secondary ? {base: 'wrap', md: 'nowrap'} : 'unset'}
            p="10px"
            borderRadius="30px"
            boxShadow={shadow}>
            <SidebarResponsive routes={routes.filter(route => ['/user'].includes(route.layout))}/>
        </Flex>
    );
}

HeaderLinks.propTypes = {
    variant: PropTypes.string,
    fixed: PropTypes.bool,
    secondary: PropTypes.bool,
    onOpen: PropTypes.func
};
